<template>
    <div>
        <div class="granturi-header">
            <div class="data">
                <b-icon-clock></b-icon-clock>
                <span class="mt-1">{{ timestamp }}</span>
            </div>
            <div class="name">
                <b-icon-person-circle></b-icon-person-circle>
                <span class="mt-1">{{ name }}</span>
            </div>
            <div class="project">
                <b-icon-building></b-icon-building>
                <span class="mt-1">{{ business.slice(0, 19) }}...</span>
            </div>
            <div class="notifications">
                <b-icon-bell></b-icon-bell>
                <span class="mt-1">Notificări</span>
            </div>
        </div>
        <router-view :allData="allData"></router-view>
    </div>
</template>

<script>
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faArrowsAltH} from '@fortawesome/free-solid-svg-icons'
    import {faExpandArrowsAlt} from '@fortawesome/free-solid-svg-icons'
    import {faSyncAlt} from '@fortawesome/free-solid-svg-icons'

    library.add(faArrowsAltH, faExpandArrowsAlt, faSyncAlt)
    import { BIconInfoCircleFill,BIconPersonCircle, BIconClock, BIconBell, BIconBuilding } from "bootstrap-vue";
    export default {
        components: {
            FontAwesomeIcon,
            BIconInfoCircleFill,
            BIconClock,
            BIconPersonCircle,
            BIconBell,
            BIconBuilding
        },
        data() {
            return {
                timestamp: '',
                name: '',
                business: JSON.parse(localStorage.getItem('currentM3Company')).name,
                projectName: '',
                projectCode: '',
            }
        },
        computed: {
            allData() {
                return this.$store.getters['m3Sketch/allData']
            }
        },
        mounted() {
            this.name = this.$store.getters['auth/user'].name
            if(this.allData.m3_project.mysmis) {
                this.projectName = this.allData.m3_project.mysmis.title
                this.projectCode = this.allData.m3_project.mysmis.code
            }
        },
        created() {
            setInterval(this.getNow, 1000);
        },
        methods: {
            getNow: function() {
                const today = new Date();
                const date = today.getDate()+'/'+(today.getMonth()+1)+'/'+today.getFullYear();
                const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                const dateTime = time +' '+ date;
                this.timestamp = dateTime;
            }
        }
    }
</script>

<style scoped>
.granturi-header{
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    align-items: center;
    box-shadow: 0 4px 3px -2px #00000036;
    min-height: 61px;
    background-color: #ffffff;
    padding-right: 20px;
    position: relative;
    z-index: 10;
}
.granturi-header svg {
    color:  rgb(100,116,139);
    font-size: 25px;
}

.data,
.name,
.notifications,
.project{
    display: flex;
    align-items: center;
    font-size: 12px;
    flex-direction: column;
    margin-left: 20px;
    color: rgb(100,116,139);
    font-weight: 500;
}
.name span,
.project span {
    text-transform: uppercase;
}

</style>
